import { Button, Icons, LoadingIndicator } from '@commenda/kakashi';
import commendaLoadingAnimation from '@commenda/kakashi/src/components/Loading/commenda-loading-animation.json';
import { PaymentStatus } from '@commenda/types/src/billing/types';
import Lottie from 'lottie-react';
import { TPaymentLoadingAction } from '../types';

export const PaymentLoadingPage = ({
  status,
  message,
  title,
  actions,
}: {
  status: PaymentStatus;
  message: string;
  title: string;
  actions?: TPaymentLoadingAction[];
}) => {
  let iconJsx;
  switch (status) {
    case PaymentStatus.FULFILLMENT_PROCESSED:
      iconJsx = (
        <div className="size-14 rounded-xl bg-bg-success flex justify-center items-center">
          <Icons.Check className="size-7 text-text-success" />
        </div>
      );
      break;
    case PaymentStatus.FULFILLMENT_FAILED:
    case PaymentStatus.PAYMENT_FAILED:
    case PaymentStatus.CONNECTION_TIMEOUT:
    case PaymentStatus.MAX_RETRIES_REACHED:
      iconJsx = (
        <div className="size-14 rounded-xl bg-bg-error flex justify-center items-center">
          <Icons.AlertTriangle className="size-7 text-text-error" />
        </div>
      );
      break;
    case PaymentStatus.PAYMENT_SUCCESS:
    case PaymentStatus.LOADING:
      iconJsx = (
        <div className="size-14 rounded-xl bg-bg-primary flex justify-center items-center">
          <Lottie
            animationData={commendaLoadingAnimation}
            loop
            autoplay
            style={{ width: 96, height: 96, transform: 'scale(3)' }}
          />
        </div>
      );
      break;
    default:
      iconJsx = null;
      break;
  }
  return (
    <div className="flex w-full flex-col h-screen">
      <div className="h-[calc(100vh-80px)] w-full flex flex-col justify-center items-center gap-10 p-6 md:p-10">
        <div className="flex flex-col justify-center items-center">
          {iconJsx}
          <h3 className="txt-extra-large-bold text-text-primary mt-4">
            {title}
          </h3>
          <p className="txt-small-regular text-text-tertiary mt-1 max-w-[500px] text-center">
            {message}
          </p>
        </div>
        <div className="hidden lg:flex gap-4">
          {actions?.map((action) => (
            <Button
              key={action.text}
              size="md"
              disabled={action.isLoading}
              onClick={action.onClick}
              variant={action.variant}
            >
              {action.isLoading ? <LoadingIndicator /> : null}
              {action.text}
            </Button>
          ))}
        </div>
        <p className="txt-small-regular text-text-tertiary lg:hidden text-center max-w-[500px]">
          Please log in using a desktop to continue. We&apos;re working on
          adding mobile support soon for a smoother and more seamless
          experience!
        </p>
      </div>
    </div>
  );
};
